import { render, staticRenderFns } from "./ListadoDetallesPagosUniversidadesAgrupados.vue?vue&type=template&id=3aac5fa7"
import script from "./ListadoDetallesPagosUniversidadesAgrupados.vue?vue&type=script&lang=js"
export * from "./ListadoDetallesPagosUniversidadesAgrupados.vue?vue&type=script&lang=js"
import style0 from "./ListadoDetallesPagosUniversidadesAgrupados.vue?vue&type=style&index=0&id=3aac5fa7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports